import { render } from "./EditClientAttributeMaster.vue?vue&type=template&id=fc1cc11e"
import script from "./EditClientAttributeMaster.vue?vue&type=script&lang=js"
export * from "./EditClientAttributeMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__